<template>
  <span class="intervalbody">
    <span style="font-size:12px">{{label}}</span>
    <span class="span-m">
      <span :key="index" v-for="(i,index) in timestype" @click="nowSelect = i.en">
        <img :src="getImg(i.en)" />{{i.ch}}
      </span>
    </span>
  </span>
</template>
<script>
  import resourcesStore from '@/cache/resourcesStore.js'
  export default {
    components: {},
    /* props: [
      "label" //主题
    ], */
    props: {
      label: {
        type: String
      }, //主题
      userDefined: {
        type: Boolean,
        default () {
          return false
        }
      },
      noQuarter: {
        type: Boolean,
        default () {
          return false
        }
      }
    },
    data () {
      return {
        timestype: [{
          ch: '日',
          en: 'day'
        },
        // {
        // 	ch: '周',
        // 	en: 'week'
        // },
        {
          ch: '月',
          en: 'month'
        },
        // {
        // 	ch: '季',
        // 	en: 'quarter'
        // },
        {
          ch: '年',
          en: 'year'
        }
        ],
        nowSelect: 'day'
      }
    },
    mounted () {
      if(this.userDefined) {
        this.timestype.push({ch: '时间段',en: 'custom'})
      }
      if(this.noQuarter) {
        this.timestype.splice(3,1)
      }
      if(this.defaulttimetype) {
        this.nowSelect=this.defaulttimetype
      } else {
        this.$emit('selectTimetype',this.nowSelect)
      }
    },
    computed: {
      getImg () {
        return i => {
          if(i==this.nowSelect) {
            return resourcesStore.getters.getResourcesByName("checkBox/checked.png")
          }
          return resourcesStore.getters.getResourcesByName("checkBox/unchecked.png")
        }
      }
    },
    watch: {
      nowSelect (nv,ov) {
        this.$emit('selectTimetype',nv)
      }
    }
  }
</script>

<style scoped>
  .span-m {
    border: solid #d4d4d4 .01rem;
    border-radius: .05rem;
    line-height: 36px;
    margin: 0 5px;
    height: 34px;
    padding: 0 5px;
    padding-left: 15px;
    display: flex;
    align-items: center;
    color: white;
  }

  .span-m span {
    text-align: center;
    display: flex;
    align-items: center;
    margin-right: 0.15rem;
    color: black;
  }

  .intervalbody {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .intervalbody img {
    width: .13rem;
    height: .13rem;
    margin-right: .05rem;
    cursor: pointer;
  }
</style>